import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", d: "M2 2a1 1 0 00-1 1v15c0 .6.4 1 1 1h7a2 2 0 012 2 1 1 0 102 0 2 2 0 012-2h7c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1h-6a5 5 0 00-4 2 5 5 0 00-4-2H2zm11 15.5a4 4 0 012-.5h6V4h-5a3 3 0 00-3 3v10.5zm-2 0V7a3 3 0 00-3-3H3v13h6a4 4 0 012 .5z", clipRule: "evenodd" }));
export {
  a as ReactComponent
};
